import Tooltip from '../common/Tooltip';
import { colorDisplayName } from '../../utils/paletteColors';
import { getPrimaryDark } from '../../constants/constants';
import { iconButtonStyle, isLightColor, navbarButtonStyle } from '../../utils/styles';
import { Checkable } from '../common/Checkable';
import DuotoneLightIcon from '../common/DuotoneLightIcon';
import { useStore } from '../../store/store';

const ColorButton = ({
  active,
  label,
  // Nom donné à la couleur dans la palette du document : montré au survol, la
  // pastille seule ne distinguant pas deux teintes voisines.
  name,
  // Couleur du texte qu'une pastille « transparent » suit : elle se montre alors
  // dans cette couleur, marquée d'un « A », au lieu de la corbeille rouge de
  // « aucune couleur » (puces de liste, qui suivent le texte tant qu'elles n'ont
  // pas la leur).
  inheritStyle,
  size,
  onToggle,
  colorStyle,
  positionStyle
}) => {
  const isTemplate = useStore(({ currentDocument }) => currentDocument.type === 'template')

  const followsText = label === 'transparent' && !!inheritStyle;

  const toggle = (e) => {
    e.preventDefault();
    onToggle(label);
  };
  return (
    <Tooltip title={colorDisplayName({ label, name, style: colorStyle })} mouseLeaveDelay={0}>
      <div
        style={{
          ...positionStyle
        }}
      >
      <Checkable checked={active && (label !== 'transparent' || followsText)}>
        <div style={{
          ...navbarButtonStyle,
          height: size,
          width: size,
          marginBottom: '1px',
          position: 'relative',
          borderColor: getPrimaryDark(isTemplate),
        }}>
          <div
            style={{
              height: size,
              width: size,
              background: `repeating-conic-gradient(#000 0% 25%, #eee 0% 50%) 50%/16px 16px`,
            }}>
          </div>
          <div
            style={{
              height: '100%',
              width: '100%',
              backgroundColor: followsText
                ? inheritStyle
                : colorStyle === 'transparent' ? 'white' : colorStyle,
              position: 'absolute',
              top: 0,
              left: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            onMouseDown={onToggle ? toggle : null}
          >
            {followsText ? (
              <p
                style={{
                  ...iconButtonStyle(),
                  fontFamily: 'monospace',
                  color: isLightColor(inheritStyle) ? '#000' : '#fff',
                }}
              >
                A
              </p>
            ) : label === 'transparent' ? (
              <DuotoneLightIcon name='trash' className='box-delete-icon' style={{ ...iconButtonStyle(), color: '#FF0000' }} />
            ) : null}
          </div>
        </div>
        </Checkable>
      </div>
    </Tooltip>
  );
};

export default ColorButton;
